var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"dense":"","ripple":_vm.clickable,"to":_vm.to,"color":"primary"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }